import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  AddEmployeesToOverrideInput,
  AddEmployeesToOverrideVariables,
  AddEmployeesToOverrideMutationResponse,
} from '../types';

const addEmployeesToOverrideMutation = gql`
  mutation AddEmployeesToOverride($input: AddEmployeesToOverrideInput!) {
    payrollAddEmployeesToOverride(input: $input) {
      code
      success
      message
      data
    }
  }
`;

export const addEmployeesToOverride = (
  input: AddEmployeesToOverrideInput,
): Promise<AddEmployeesToOverrideMutationResponse> => {
  return graphQLApi<AddEmployeesToOverrideMutationResponse, AddEmployeesToOverrideVariables>({
    query: addEmployeesToOverrideMutation,
    queryVariables: {
      input,
    },
  });
};

